import { browserHistory } from '@/routing/browserHistory';
import { getParameterizedLink } from '@/utils/getLinkWithSubscriptionId.utils';
import { SearchTagType } from '@/graphql/contracts/_generated_/contracts';
import { Pill } from '@/components/common/Pill/Pill';
import { contractsBCPath } from '@/utils/path.utlis';

export interface ISearchTag {
  searchTag: SearchTagType;
}

const SEARCHTYPE = {
  CUSTOMER: 'CUSTOMER',
  CONTRACT: 'CONTRACT'
};

const SEARCH_TAG_VISIBLE_CHARS_LENGTH = 25;

const tagStyle = {
  height: 26,
  lineHeight: '26px',
  fontWeight: 500,
  fontSize: 12,
  cursor: 'pointer'
};

function SearchTag({ searchTag }: ISearchTag) {
  const searchTagCropped = searchTag.tag.length > SEARCH_TAG_VISIBLE_CHARS_LENGTH ?
    searchTag.tag.slice(0, SEARCH_TAG_VISIBLE_CHARS_LENGTH) + '...' : searchTag.tag;

  const handleNavigate = (tag: SearchTagType) => {
    if (tag.tagType === SEARCHTYPE.CUSTOMER) {
      browserHistory.push(getParameterizedLink(`/${contractsBCPath}?search=${encodeURIComponent(tag.tag)}`));
    } else {
      browserHistory.push(getParameterizedLink(`/${contractsBCPath}/${tag.targetID}`));
    }
  };

  return (
    <Pill
      name={searchTag.tag}
      title={searchTag.tag}
      style={tagStyle}
      onClick={() => handleNavigate(searchTag)}
    >
      {searchTagCropped}
    </Pill>
  );
}

export default SearchTag;